// Misc
import React, { Component, createElement, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import { NavLink, Route, Switch } from 'react-router-dom'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Logo from 'components/Layout/Logo'
import Link from 'atoms/Link'

// Icons
import MenuIcon from '@material-ui/icons/Menu'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'

// Components
import { BaseLayoutContent, BaseLayoutAppBar } from 'components/Layout/BaseLayout'
import UserMenu from './UserMenu'

// Styles
const styles = theme => ({
  drawerPaper: {
    backgroundColor: theme.palette.secondary.main,
  },
  drawerLogo: {
    padding: theme.spacing.unit * 2,
  },
  link: {
    color: theme.palette.secondary.contrastText,
    borderLeft: '2px solid transparent',
  },
  linkIcon: {
    color: 'inherit',
    marginRight: 0,
  },
  linkText: {
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
  },
  linkActive: {
    borderColor: theme.palette.primary.main,
  },
  menuButtonWrapper: {
    flex: 1,
    lineHeight: 0,
  },
  appBarButton: {
    marginLeft: -theme.spacing.unit * 2
  }
})

export default
@withStyles(styles)
class MobileUserLayout extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    userMenuLinks: PropTypes.array.isRequired,
    sidebarLinks: PropTypes.array.isRequired,
    children: PropTypes.any,
  }

  state = {
    menuOpen: false,
  }

  toggleMenu = () => {
    const { menuOpen } = this.state
    this.setState({ menuOpen: !menuOpen })
  }

  renderLink = (link) => {
    const { classes } = this.props
    return (
      <ListItem
        button
        component={NavLink}
        to={link.to}
        key={link.to}
        className={classes.link}
        activeClassName={classes.linkActive}
        onClick={this.toggleMenu}
      >
        <ListItemIcon className={classes.linkIcon}>
          { createElement(link.icon) }
        </ListItemIcon>
        <ListItemText
          primary={link.label}
          primaryTypographyProps={{ className: classes.linkText }}
        />
      </ListItem>
    )
  }

  renderAppBarBackButton = props => () => {
    const { classes } = this.props
    return (
      <BaseLayoutAppBar>
        <IconButton
          {...props}
          className={classes.appBarButton}
        >
          <ArrowBackIosIcon />
        </IconButton>
      </BaseLayoutAppBar>
    )
  }

  renderAppBarMenu = () => {
    const { classes, userMenuLinks } = this.props
    return (
      <BaseLayoutAppBar>
        <div className={classes.menuButtonWrapper}>
          <IconButton
            onClick={this.toggleMenu}
            className={classes.appBarButton}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <UserMenu links={userMenuLinks} />
      </BaseLayoutAppBar>
    )
  }

  renderAppBar() {
    return (
      <Switch component={null}>
        <Route path="/build/:proposalUuid" render={this.renderAppBarBackButton({ to: '/build', component: Link })} />
        <Route path="/integrations/:integration" render={this.renderAppBarBackButton({ to: '/integrations', component: Link })} />
        <Route path="/team/create" render={this.renderAppBarBackButton({ to: '/team', component: Link })} />
        <Route path="/team/:managerUuid" render={this.renderAppBarBackButton({ to: '/team', component: Link })} />
        <Route path="/inbox/request/:requestId" />
        <Route path="/inbox/livechat/:liveChatUuid" />
        <Route render={this.renderAppBarMenu} />
      </Switch>
    )
  }

  renderDrawerContent() {
    const { sidebarLinks, classes } = this.props
    return (
      <Fragment>
        <div className={classes.drawerLogo}>
          <Logo contrast />
        </div>
        <List disablePadding>
          { sidebarLinks.map(this.renderLink) }
        </List>
      </Fragment>
    )
  }

  render() {
    const { classes, children } = this.props
    const { menuOpen } = this.state
    return (
      <div>
        <Drawer
          open={menuOpen}
          onClose={this.toggleMenu}
          classes={{ paper: classes.drawerPaper }}
        >
          { this.renderDrawerContent() }
        </Drawer>
        { this.renderAppBar() }
        <BaseLayoutContent>
          { children }
        </BaseLayoutContent>
      </div>
    )
  }
}
